import { FormsRegisterCreatedAtField } from './forms-register-created-at-field';
import { FormsRegisterCreatedByField } from './forms-register-created-by-field';
import { FormsRegisterFormIdField } from './forms-register-form-id-field';
import { FormsRegisterFormNumberField } from './forms-register-form-number-item';
import { FormsRegisterFormVersionField } from './forms-register-form-version-field';
import { FormsRegisterProjectField } from './forms-register-project-field';
import { FormsRegisterStaticField } from './forms-register-static-field';
import { FormsRegisterTeamField } from './forms-register-team-field';
import { FormsRegisterUpdatedAtField } from './forms-register-updated-at-field';
import { FormsRegisterWorkflowStepField } from './forms-register-workflow-step-field';
import { StaticFieldIds } from './static-field-ids.enum';

export class FormsRegisterStaticFieldFactory {
  private static resolver: Record<StaticFieldIds, { new ({ form, template }): FormsRegisterStaticField }> = {
    [StaticFieldIds.CreatedAt]: FormsRegisterCreatedAtField,
    [StaticFieldIds.CreatedBy]: FormsRegisterCreatedByField,
    [StaticFieldIds.FormNumber]: FormsRegisterFormNumberField,
    [StaticFieldIds.FormVersion]: FormsRegisterFormVersionField,
    [StaticFieldIds.Project]: FormsRegisterProjectField,
    [StaticFieldIds.Team]: FormsRegisterTeamField,
    [StaticFieldIds.WorkflowStep]: FormsRegisterWorkflowStepField,
    [StaticFieldIds.UpdatedAt]: FormsRegisterUpdatedAtField,
    [StaticFieldIds.Id]: FormsRegisterFormIdField,
  };

  static getStaticFormField({ form, template, kind }: { form: any; kind: StaticFieldIds; template: any }) {
    if (!this.resolver[kind]) {
      throw new Error('Unknown static field type');
    }

    const Field = this.resolver[kind];

    return new Field({ form, template });
  }
}
